var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EventLink',{staticClass:"content-card-link",attrs:{"id":`link--${_vm.component.id}`,"event":"common.cms.link:click","linkComponent":_vm.component}},[_c('ContentCard',{attrs:{"id":_vm.component.id,"src":_vm.src('image'),"logo":_vm.src('logo'),"title":_vm.title,"subtitle":_vm.subtitle,"date":_vm.date,"fixedHeight":_vm.fixedHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }